import React from 'react';

const ORDER = ['A', 'M', 'U'];
const LABELS = { A: 'Arvode', M: 'Bilersättning', U: 'Utlägg' };
// 'M' IS THE INTERNAL CODE (TIED TO ReimbursementModel.MileageId / THE STORED "M" IN ReimbursementTypes),
// BUT THE SYSTEM CALLS THIS "BILERSÄTTNING", SO IT DISPLAYS AS "B".
const DISPLAY_LETTER = { A: 'A', M: 'B', U: 'U' };

const badgeStyle = {
    width: '24px',
    height: '18px',
    fontSize: '12px',
    borderRadius: '6px',
    cursor: 'default',
};

// RENDERS THE A/M/U REIMBURSEMENT TYPE BADGES (SAME STYLE USED IN THE PAYOUT STAGE).
// EACH LETTER ALWAYS KEEPS ITS OWN FIXED SLOT SO ROWS STAY VISUALLY ALIGNED REGARDLESS
// OF WHICH TYPES ARE PRESENT (E.G. "M U" DOESN'T SHIFT LEFT INTO "A"'S SPOT).
export function ReimbursementTypeBadges({ types, className = '', center = false }) {
    if (!types || types.length === 0) return null;

    return (
        <div
            className={`d-flex align-items-center ${center ? 'justify-content-center' : ''} ${className}`}
            style={{ gap: '6px', width: center ? '100%' : undefined }}
        >
            {ORDER.map(type => (
                <div key={type} className="d-flex justify-content-center align-items-center" style={{ width: '24px', height: '18px' }}>
                    {types.includes(type) && (
                        <span className="badge-amu-wrapper">
                            <span
                                className="fw-bold bg-green-light text-green d-flex align-items-center justify-content-center"
                                style={badgeStyle}
                            >
                                {DISPLAY_LETTER[type]}
                            </span>
                            <span className="badge-amu-tooltip">{LABELS[type]}</span>
                        </span>
                    )}
                </div>
            ))}
        </div>
    );
}

// DERIVES THE A/M/U TYPES DIRECTLY FROM A RAW REIMBURSEMENT MODEL (fixedIds/mileageId/expenseIds)
export function getReimbursementTypesFromReimbursement(reimbursement) {
    if (!reimbursement) return [];

    const types = [];
    if (reimbursement.fixedIds && reimbursement.fixedIds.length > 0) types.push('A');
    if (reimbursement.mileageId) types.push('M');
    if (reimbursement.expenseIds && reimbursement.expenseIds.length > 0) types.push('U');
    return types;
}

// MERGES THE reimbursementTypes OF EVERY SUB-ITEM IN A PAYMENT'S paymentDetails INTO ONE
// DEDUPED LIST (E.G. A PAYMENT BUNDLING ONE "A" PROCEEDING AND ONE "U" PROCEEDING SHOWS "A U"
// ONCE ON THE ROW, NOT "A U" PER SUB-ITEM OR REPEATED LETTERS).
export function getUnionReimbursementTypes(paymentDetails) {
    if (!Array.isArray(paymentDetails)) return [];

    const union = new Set();
    paymentDetails.forEach(detail => {
        (detail?.reimbursementTypes || []).forEach(type => union.add(type));
    });
    return ORDER.filter(type => union.has(type));
}

export default ReimbursementTypeBadges;
